"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberMultiSelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("@/app/shared/constants");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
const multiSelect_1 = require("@/app/SUMO/components/multiSelect");
const outline_1 = require("@heroicons/react/24/outline");
const EmailValidator = __importStar(require("email-validator"));
const button_1 = require("primereact/button");
const inputtext_1 = require("primereact/inputtext");
const overlaypanel_1 = require("primereact/overlaypanel");
const progressspinner_1 = require("primereact/progressspinner");
const utils_1 = require("primereact/utils");
const react_1 = require("react");
const lib_1 = require("use-debounce/lib");
const uuid_1 = require("uuid");
const MemberMultiSelect = ({ options, mainGuest, starOptions = ["ANY" /* MemberSubType.ANY */], usersColor, selectedIds = [], disabled, invalid, onChange, onSearch, onDebounceSearch, debounceDelay = constants_1.DELAY_INPUT_UPDATE_MILLISECONDS, isLoading, }) => {
    const overlayPanelRef = (0, react_1.useRef)(null);
    const [localSelectedIds, setLocalSelectedIds] = (0, react_1.useState)(selectedIds);
    const [search, setSearch] = (0, react_1.useState)('');
    const [debouncedText] = (0, lib_1.useDebounce)(search, debounceDelay);
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (e) => {
            const overlayEl = overlayPanelRef.current?.getElement();
            if (overlayEl && !overlayEl.contains(e.target)) {
                overlayPanelRef.current?.hide();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    (0, react_1.useEffect)(() => {
        onDebounceSearch?.(debouncedText);
    }, [debouncedText]);
    (0, react_1.useEffect)(() => {
        setLocalSelectedIds(selectedIds);
    }, [selectedIds]);
    const handleChange = (updatedIds, updatedOptions) => {
        onChange(updatedIds.map((id) => (updatedOptions || options).find((item) => item.id === id)));
        setLocalSelectedIds(updatedIds);
    };
    const handleOptionClick = (option) => {
        if (!option.id)
            return;
        const isSelected = localSelectedIds.includes(option.id);
        const updatedIds = isSelected ? localSelectedIds.filter((id) => id !== option.id) : [...localSelectedIds, option.id];
        handleChange(updatedIds);
    };
    const handleFirstOptionSet = (option) => {
        if (!option.id)
            return;
        const updatedIds = [option.id, ...localSelectedIds.filter((id) => id !== option.id)];
        handleChange(updatedIds);
    };
    const handleOptionRemove = (option) => {
        if (!option.id)
            return;
        const updatedIds = localSelectedIds.filter((id) => id !== option.id);
        handleChange(updatedIds);
    };
    const handleOnSearch = (value) => {
        setSearch(value);
        onSearch?.(value);
    };
    const handleAddGuest = () => {
        const email = search.trim();
        const isEmailValid = EmailValidator.validate(email);
        if (!isEmailValid)
            return;
        const newGuest = {
            id: (0, uuid_1.v4)(),
            type: "CUSTOM" /* MemberType.CUSTOM */,
            subType: "CONTACT" /* MemberSubType.CONTACT */,
            email,
            workspaceIds: [],
        };
        const updatedOptions = [...options, newGuest];
        const updatedIds = [...localSelectedIds, newGuest.id];
        handleChange(updatedIds, updatedOptions);
        overlayPanelRef.current?.hide();
        handleOnSearch('');
    };
    const searchOptions = (0, react_1.useMemo)(() => search
        ? options.filter((option) => {
            const SearchString = search.toLowerCase();
            const name = option?.name?.toLowerCase();
            const email = option?.email?.toLowerCase();
            return name?.includes(SearchString) || email?.includes(SearchString);
        })
        : options, [search, options]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(overlaypanel_1.OverlayPanel, { ref: overlayPanelRef, className: 'w-320px p-4px', dismissable: false, children: (0, jsx_runtime_1.jsxs)("div", { className: 'flex flex-column', children: [(0, jsx_runtime_1.jsxs)("div", { className: (0, utils_1.classNames)('flex-left-center gap-8px p-12px', searchOptions.length > 0 && 'border-bottom-1 border-gray-20 mb-4px'), children: [(0, jsx_runtime_1.jsx)(outline_1.MagnifyingGlassIcon, { className: 'flex-none icon-20px text-gray-50' }), (0, jsx_runtime_1.jsx)("div", { className: 'flex-1', children: (0, jsx_runtime_1.jsx)(inputtext_1.InputText, { className: 'w-full p-0 border-none border-radius-none', placeholder: labels_1.default.SEARCH_ATTENDEE_PLACEHOLDER, value: search, onChange: (e) => handleOnSearch(e.target.value) }) }), search && ((0, jsx_runtime_1.jsx)(outline_1.XMarkIcon, { className: 'flex-none icon-20px text-gray-50 hover-text-gray-100 cursor-pointer', onClick: () => handleOnSearch('') }))] }), (0, jsx_runtime_1.jsx)("div", { className: 'flex flex-column max-h-500px overflow-y-auto', children: searchOptions.map((option) => ((0, jsx_runtime_1.jsx)(multiSelect_1.SelectItem, { option: option, localSelectedIds: localSelectedIds, handleOptionClick: handleOptionClick }, option.id))) }), searchOptions.length === 0 && ((0, jsx_runtime_1.jsx)(button_1.Button, { className: 'w-full', label: localSelectedIds.length ? labels_1.default.SCHEDULER_ADD_ATTENDEE : labels_1.default.SCHEDULER_ADD_INVITEE, onClick: handleAddGuest, disabled: !search })), isLoading && ((0, jsx_runtime_1.jsx)("div", { className: 'flex align-items-center justify-content-center p-4px', children: (0, jsx_runtime_1.jsx)(progressspinner_1.ProgressSpinner, { className: 'w-20px h-20px', strokeWidth: '5' }) }))] }) }), (0, jsx_runtime_1.jsxs)("div", { className: 'flex flex-column', children: [(0, jsx_runtime_1.jsx)("div", { className: (0, utils_1.classNames)('add-button mr-20px', disabled && 'p-disabled', invalid && 'p-invalid'), onClick: (e) => !disabled && overlayPanelRef.current?.toggle(e), children: (0, jsx_runtime_1.jsx)(outline_1.PlusIcon, { className: 'icon-16px' }) }), localSelectedIds.length > 0 && ((0, jsx_runtime_1.jsx)("div", { className: 'flex flex-column gap-8px mt-12px', children: localSelectedIds
                            .map((id) => options.find((item) => item.id === id))
                            .filter((option) => Boolean(option?.id))
                            .map((option) => ((0, jsx_runtime_1.jsx)(multiSelect_1.SelectValue, { option: option, members: option.members, mainGuest: mainGuest, starOptions: starOptions, usersColor: usersColor, handleFirstOptionSet: handleFirstOptionSet, onHostRemove: handleOptionRemove }, option.id))) }))] })] }));
};
exports.MemberMultiSelect = MemberMultiSelect;
